var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container detail" }, [
    _c("div", { staticClass: "detail-header" }, [
      _c("div", { staticClass: "information" }, [
        _c("div", { staticClass: "theme" }, [
          _c(
            "span",
            { staticStyle: { "font-weight": "600", "margin-right": "10px" } },
            [_vm._v("主题:")]
          ),
          _vm._v(" "),
          _c("span", { staticStyle: { "font-weight": "600" } }, [
            _vm._v(_vm._s(_vm.title))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "recipients" }, [
          _vm.type == "outbox"
            ? _c("span", { staticStyle: { "margin-right": "10px" } }, [
                _vm._v("收件人:")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.type == "inbox"
            ? _c("span", { staticStyle: { "margin-right": "10px" } }, [
                _vm._v("发件人:")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.name))])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "date" }, [
          _c("span", { staticStyle: { "margin-right": "10px" } }, [
            _vm._v("时间:")
          ]),
          _vm._v(_vm._s(_vm.sendTime) + "\r\n              ")
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "section" }, [
      _c("div", { domProps: { innerHTML: _vm._s(_vm.contents) } })
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "foot" },
      _vm._l(_vm.accessoryList, function(item, index) {
        return _c("div", { key: index, staticClass: "accessory" }, [
          _c("img", {
            staticClass: "accessory_img",
            attrs: { src: item.attachment }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "accessory_label" }, [
            _vm._v(_vm._s(item.accessoryName))
          ])
        ])
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-85d225c8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85d225c8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/mywayinfo-message-components/src/detail.vue
// module id = null
// module chunks = 